"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.benefits.precise_interactions': 'Risoluzione precisa e rapida delle interazioni con i clienti, garantendo alta qualità ed efficienza.',
    'onboarding.benefits.customer_satisfaction': 'Massimizzazione degli indicatori di Soddisfazione del Cliente attraverso un servizio migliorato e istantaneo.',
    'onboarding.benefits.workflow_automation': 'Automatizzazione completa dei flussi di lavoro chiave, portando a una significativa riduzione dei costi operativi e liberazione delle risorse umane.',
    'onboarding.benefits.real_time_insights': 'Uso efficace dei dati in tempo reale per generare intuizioni profonde e guidare la crescita aziendale sostenibile.',
};
